import { clientMount } from '@vp/ubik-fragment-react'
import type { MountWithRootOptions } from '@vp/ubik-fragment-types'
import { HomepageFeatureTileRow } from '../components/FeatureTileRow/homepage-feature-tile-row'
import type { AppProps } from '../types/homepageFeatureTileRow'
export const mount: MountWithRootOptions<AppProps> = async (rootElement, renderProps, rootOptions) => {
  return clientMount(<HomepageFeatureTileRow {...renderProps} />, rootElement, rootOptions)
}
